<template lang="pug">
  section
    AlertBox(ref="errorMsg")
    v-flex(xs12)
      v-alert(v-if="hadResultMessage" type="info" value="true") {{ resultList.resultMessage }}
    v-flex(xs12 v-if="isFilterError || (hadWork && !hadResultMessage && !noWorkImportRow)")
      v-card
        v-card-title(v-if="!canImport")
          v-layout
            v-flex(xs12)
              v-alert(:value="true" type="warning" outline) 1件でもエラーがある場合は取込出来ません
        v-card-title(class="header-summary")
          div.mr-2(v-show="!hadResultMessage")
            span 件数：{{ workListAllCount }} 件
            span.ml-2 エラー件数：{{ workListErrorCount }} 件
          v-checkbox(v-show="!hadResultMessage" label="エラーのみ表示" :value="isFilterError" v-on:change="toggleFilterError")
          v-btn(v-show="!hadResult && !hadResultMessage && !noWorkImportRow" color="success"
            :disabled="!canImport"
            @click="commit" class="commit-btn" :loading="getLoadingStatus") 取込確定

        v-card-text
          section.table-scroll-x.sticky-container(ref="container")
            table
              thead
                tr
                  th(rowspan=2) 該当行
                  th(rowspan=2 width="65px") 取込対象
                  th(rowspan=2) 荷主CD
                  th(rowspan=2) 荷主名
                  th(rowspan=2) 荷主枝番ID
                  th(rowspan=2) 荷主枝番名
                  th(rowspan=2) 請求区分CD
                  th(rowspan=2) 請求区分
                  th(rowspan=2) 距離区分
                  th(rowspan=2) 受注日
                  th(rowspan=2) 積込予定日
                  th(rowspan=2) 納品予定日
                  th(rowspan=2) 車格
                  th(rowspan=2) 積載重量(kg)
                  th(rowspan=2) 台数
                  th(rowspan=2) 積荷種別
                  th(rowspan=2) 積荷重量(kg)
                  th(rowspan=2) 荷役区分
                  th(rowspan=2) 配車カードマーク
                  // 積地フィールド群
                  th(rowspan=2) 積地CD1
                  th(rowspan=2) 積地名1
                  th(rowspan=2) 積地CD2
                  th(rowspan=2) 積地名2
                  th(rowspan=2) 積地CD3
                  th(rowspan=2) 積地名3
                  th(rowspan=2) 積地CD4
                  th(rowspan=2) 積地名4
                  th(rowspan=2) 積地CD5
                  th(rowspan=2) 積地名5
                  // 卸地フィールド群
                  th(rowspan=2) 卸地CD1
                  th(rowspan=2) 卸地名1
                  th(rowspan=2) 卸地時間指定開始1
                  th(rowspan=2) 卸地時間指定終了1
                  th(rowspan=2) 卸順1
                  th(rowspan=2) 卸地CD2
                  th(rowspan=2) 卸地名2
                  th(rowspan=2) 卸地時間指定開始2
                  th(rowspan=2) 卸地時間指定終了2
                  th(rowspan=2) 卸順2
                  th(rowspan=2) 卸地CD3
                  th(rowspan=2) 卸地名3
                  th(rowspan=2) 卸地時間指定開始3
                  th(rowspan=2) 卸地時間指定終了3
                  th(rowspan=2) 卸順3
                  th(rowspan=2) 卸地CD4
                  th(rowspan=2) 卸地名4
                  th(rowspan=2) 卸地時間指定開始4
                  th(rowspan=2) 卸地時間指定終了4
                  th(rowspan=2) 卸順4
                  th(rowspan=2) 卸地CD5
                  th(rowspan=2) 卸地名5
                  th(rowspan=2) 卸地時間指定開始5
                  th(rowspan=2) 卸地時間指定終了5
                  th(rowspan=2) 卸順5
                  th(rowspan=2) {{ getBillingItemName('BASIC_RATE') }}
                  th(rowspan=2) {{ getBillingItemName('MULTI_DELI') }}
                  th(rowspan=2) {{ getBillingItemName('SPECIAL_COST') }}
                  th(rowspan=2) {{ getBillingItemName('TOLL') }}
                  th(rowspan=2) {{ getBillingItemName('LOADING_PALLET') }}
                  th(rowspan=2) {{ getBillingItemName('UNLOADING_PALLET') }}
                  th(rowspan=2) {{ getBillingItemName('WAITING_COST') }}
                  th(rowspan=2) {{ getBillingItemName('ADDITIONAL_WORK') }}
                  th(rowspan=2) {{ getBillingItemName('OTHER') }}
                  th(rowspan=2) {{ getBillingItemName('SPARE1') }}
                  th(rowspan=2) {{ getBillingItemName('SPARE2') }}
                  th(rowspan=2) {{ getBillingItemName('SPARE3') }}
                  th(rowspan=2) {{ getBillingItemName('SPARE4') }}
                  th(rowspan=2) {{ getBillingItemName('SPARE5') }}
                  th(rowspan=2) 備考
                  th(rowspan=2) 会計備考
              tbody
                template(v-if="workList.length")
                  tr(v-for="(orderRec,index) in workList")
                    // 該当行
                    td.text-md-center {{ orderRec.lineNo }}

                    //取込対象
                    td.text-md-center.targetSelectCell(v-if="!hadResultMessage && !isValidError(orderRec)")
                      v-checkbox.justify-center.align-center(v-model="orderRec.importTarget" disabled)
                    td.text-md-center(v-else-if="isValidError(orderRec)")
                      // エラーがある場合
                      ImportErrorMessageBlock(:validationErrorList="orderRec.validationErrorList")
                    td(v-else)

                    td.text-md-left {{ orderRec.clientCd }}
                    td.text-md-left {{ orderRec.clientName }}
                    td.text-md-left {{ orderRec.clientBranchId }}
                    td.text-md-left {{ orderRec.clientBranchName }}
                    td.text-md-left {{ orderRec.billingTypeCd }}
                    td.text-md-left {{ orderRec.billingTypeName }}
                    td.text-md-left {{ orderRec.distanceType }}
                    td.text-md-center {{ orderRec.orderDate }}
                    td.text-md-center {{ orderRec.loadingDate }}
                    td.text-md-center {{ orderRec.unloadingDate }}
                    td.text-md-left {{ orderRec.vehicleType }}
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.carryWeight" prefix="")
                    td.text-xs-right {{ orderRec.vehicleQuantity }}
                    td.text-md-left {{ orderRec.itemTypeName }}
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.weight" prefix="")
                    td.text-md-left {{ orderRec.handlingUnitTypeName }}
                    td.text-md-center {{ orderRec.dispatchCardMark }}
                    // 積地フィールド群
                    td.text-md-left {{ orderRec.loadingBaseCd1 }}
                    td.text-md-left {{ orderRec.loadingBaseName1 }}
                    td.text-md-left {{ orderRec.loadingBaseCd2 }}
                    td.text-md-left {{ orderRec.loadingBaseName2 }}
                    td.text-md-left {{ orderRec.loadingBaseCd3 }}
                    td.text-md-left {{ orderRec.loadingBaseName3 }}
                    td.text-md-left {{ orderRec.loadingBaseCd4 }}
                    td.text-md-left {{ orderRec.loadingBaseName4 }}
                    td.text-md-left {{ orderRec.loadingBaseCd5 }}
                    td.text-md-left {{ orderRec.loadingBaseName5 }}
                    // 卸地フィールド群
                    td.text-md-left {{ orderRec.unloadingBaseCd1 }}
                    td.text-md-left {{ orderRec.unloadingBaseName1 }}
                    td.text-md-center {{ orderRec.unloadingTimeStart1 }}
                    td.text-md-center {{ orderRec.unloadingTimeEnd1 }}
                    td.text-xs-right {{ orderRec.loadUnloadOrder1 }}
                    td.text-md-left {{ orderRec.unloadingBaseCd2 }}
                    td.text-md-left {{ orderRec.unloadingBaseName2 }}
                    td.text-md-center {{ orderRec.unloadingTimeStart2 }}
                    td.text-md-center {{ orderRec.unloadingTimeEnd2 }}
                    td.text-xs-right {{ orderRec.loadUnloadOrder2 }}
                    td.text-md-left {{ orderRec.unloadingBaseCd3 }}
                    td.text-md-left {{ orderRec.unloadingBaseName3 }}
                    td.text-md-center {{ orderRec.unloadingTimeStart3 }}
                    td.text-md-center {{ orderRec.unloadingTimeEnd3 }}
                    td.text-xs-right {{ orderRec.loadUnloadOrder3 }}
                    td.text-md-left {{ orderRec.unloadingBaseCd4 }}
                    td.text-md-left {{ orderRec.unloadingBaseName4 }}
                    td.text-md-center {{ orderRec.unloadingTimeStart4 }}
                    td.text-md-center {{ orderRec.unloadingTimeEnd4 }}
                    td.text-xs-right {{ orderRec.loadUnloadOrder4 }}
                    td.text-md-left {{ orderRec.unloadingBaseCd5 }}
                    td.text-md-left {{ orderRec.unloadingBaseName5 }}
                    td.text-md-center {{ orderRec.unloadingTimeStart5 }}
                    td.text-md-center {{ orderRec.unloadingTimeEnd5 }}
                    td.text-xs-right {{ orderRec.loadUnloadOrder5 }}
                    //料金
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingBasicFarePrice")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingMultiDeliveryPrice")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpecialCostPrice")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingTollPrice")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingLoadingPalletPrice")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingUnloadingPalletPrice")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingWaitingCostPrice")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingAdditionalWorkPrice")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingOtherPrice")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpare1Price")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpare2Price")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpare3Price")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpare4Price")
                    td.text-xs-right
                      DigitSeparatorsLabel(:value="orderRec.billingSpare5Price")
                    td.text-md-left {{ orderRec.remark }}
                    td.text-md-left {{ orderRec.financeRemark }}

                template(v-else)
                  tr
                    td(:colspan="65") {{ this.$config.messages.Common.Warn.SearchResultNotFound }}

    v-flex(xs12 v-if="hadResultError")
      v-card
        v-card-text
          section
            table(class="order-table")
              thead
                tr
                  th(width="65px") 該当行
                  th エラー内容
              tbody
                tr(v-for="(data,index) in resultList.errorList")
                  td.text-md-center {{ data.lineNo }}
                  td.text-md-center {{ data.message }}
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { LabelName } from "@/assets/js/constants";
import AlertBox from "@/components/common/AlertBox";
import ImportErrorMessageBlock from "@/components/common/error/ImportErrorMessageBlock.vue";
import DispatchVehicleSelect from "@/components/dispatch/DispatchVehicleSelect.vue";
import DigitSeparatorsLabel from "@/components/common/DigitSeparatorsLabel";

export default {
  components: {
    DispatchVehicleSelect,
    ImportErrorMessageBlock,
    AlertBox,
    DigitSeparatorsLabel
  },
  data() {
    return {
      labelName: LabelName,
      pageCount: 0
    };
  },
  computed: {
    ...mapGetters("orderImport", {
      workListAllCount: "workListAllCount",
      workListErrorCount: "workListErrorCount",
      noWorkImportRow: "noWorkImportRow",
      isFilterError: "errorOnly",
      canImport: "canImport"
    }),
    ...mapGetters("indicator", {
      getLoadingStatus: "getLoadingStatus"
    }),
    workList: {
      get() {
        return this.$store.state.orderImport.workList;
      }
    },
    resultList: {
      get() {
        return this.$store.state.orderImport.workResultList;
      }
    },
    hadWork: {
      get() {
        return !(!this.workList || this.workList.length < 1);
      }
    },
    hadResult: {
      get() {
        return !(!this.resultList || this.resultList.length < 1);
      }
    },
    hadResultError: {
      get() {
        if (!this.hadResult) return false;
        return !(!this.resultList.errorList || this.resultList.errorList.length < 1);
      }
    },
    hadResultMessage: {
      get() {
        if (!this.hadResult) return false;
        return (
          this.resultList.resultMessageForManualOrder !== undefined &&
          this.resultList.resultMessageForManualOrder !== ""
        );
      }
    },
    isValidError: function () {
      return function (orderRec) {
        return Object.keys(orderRec.validationError).length;
      };
    },
    // 項目名称の動的取得
    getBillingItemName: function () {
      return function (controlCd) {
        if (this.workList.length > 0 && this.workList[0].billingItemNames) {
          return this.workList[0].billingItemNames[controlCd] || controlCd;
        }
        return controlCd;
      };
    },
    getPaymentItemName: function () {
      return function (controlCd) {
        if (this.workList.length > 0 && this.workList[0].paymentItemNames) {
          return this.workList[0].paymentItemNames[controlCd] || controlCd;
        }
        return controlCd;
      };
    }
  },
  methods: {
    /** Action：Vuex */
    ...mapActions("orderImport", {
      fetchClearWorkList: "fetchClearWorkList",
      toggleManualOrderImportErrorOnly: "toggleManualOrderImportErrorOnly"
    }),
    toggleFilterError() {
      this.toggleManualOrderImportErrorOnly(!this.isFilterError);
      this.pageCount = 0;
      this.loadWorkData();
    },
    loadWorkDataAll() {
      this.toggleManualOrderImportErrorOnly(false);
      this.loadWorkData();
    },
    loadWorkData() {
      this.$refs.errorMsg.nonDisplayMessage();
      const getParams = {
        pageCount: this.pageCount
      };
      if (!this.hadResult) {
        this.$store.dispatch("orderImport/fetchAllOrderImportWork", getParams).then(() => {
          if (this.$store.state.orderImport.noWorkImportRow) {
            if (!this.isFilterError) {
              this.$refs.errorMsg.displayMessage("取込対象データが見つかりません。");
            }
          }
        });
      }
    },
    fetchWorkListCount() {
      this.$store.dispatch("orderImport/fetchManualOrderImportWorkCount");
    },
    clearWorkData() {
      this.pageCount = 0;
      this.fetchClearWorkList();
    },
    commit() {
      this.toggleManualOrderImportErrorOnly(false);

      // 取込対象のワークデータを抽出
      const targetWorkItems = this.workList
        .filter(rec => {
          return rec.importTarget === true;
        })
        .map(value => value.id);

      this.$store.dispatch("orderImport/commitImportRequest", targetWorkItems);
    },
    displayValidate(value) {
      let list = [];
      Object.entries(value).forEach(value => {
        list.push(value[0] + " : " + value[1]);
      });
      return list.join("\n");
    },
    validStatus(data) {
      let message = "";
      // 手入力受注特有の警告メッセージがあれば追加
      return message;
    }
  },
  mounted() {
    this.clearWorkData();
    this.loadWorkData();
  }
};
</script>

<style lang="stylus" scoped>
.header-summary {
  display: flex;
  justify-content: flex-end;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  table-layout: auto;

  td {
    height: 48px;
    border: solid #dcdcdc;
    border-width: 1px 0;
    vertical-align: middle;
    padding-left: 8px;
    padding-right: 8px;
  }

  thead {
    position: sticky;
    top: 0;
    height: 54px;
    z-index: 1;

    tr {
      height: 54px;
    }

    th {
      border-right: 1px solid #E0E0E0;
      background-color: #fff;
      padding: 8px;
    }
  }

  th:last-child, td:last-child {
    border-right: none;
  }

  .no-right-border {
    border-right: none;
  }

  th:last-child.right-border {
    border-right: 1px solid #E0E0E0;
  }

  tbody {
    tr {
      transition: 0.3s;
    }

    td {
      border-right: 1px solid #E0E0E0;
    }

    td.updateCell {
      background-color: #A5D6A7 // green lighten-3
    }
  }
}

.order-table {
  border-collapse: separate;
  border-spacing: 0;

  td {
    border-bottom: none;
  }
}

.commit-btn {
  margin: 0 8px 0 40px;
}

.warning-box-icon {
  color: #FF5722;
}

.targetSelectCell {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
